import Link from 'next/link';
import Lottie from 'react-lottie';
import Text from '@components/common/text';
import Icon from '@components/common/assets';
import coinBlue from '@graphic/coinBlue.json';
import { usePassReviewPostsTop } from '@repository/passReview/usePassReview';
import { PassReviewListDto } from '@domain/rs/passReview/PassReviewPostListGetRs';
import { FontStyle } from '@domain/constant/fontStyle';
import Colors from '@domain/constant/colors';
import { RouteUrl } from '@utils/routeUtil';
import classnames from 'classnames/bind';
import styles from './index.module.scss';

const options = {
  loop: true,
  autoplay: true,
  animationData: coinBlue,
};

const cx = classnames.bind(styles);

interface ItemProps {
  ranking: number;
  data: PassReviewListDto;
}

const Item = ({ ranking, data }: ItemProps) => {
  const isTopRank = [1, 2, 3].includes(ranking);

  return (
    <Link className={cx('item')} href={`${RouteUrl.PASSBOARD}/${data.sn}`}>
      <span className={cx('rank', { isTopRank })}>{ranking}</span>
      <span className={cx('title')}>{data.title}</span>
    </Link>
  );
};

const SideBanner = () => {
  const { data } = usePassReviewPostsTop();
  const ItemEls = data?.posts.map((data, index) => <Item key={data.sn} ranking={index + 1} data={data} />);

  return (
    <div className={cx('wrapper')}>
      <Text fontStyle={FontStyle.H5_B}>합격 후기 TOP 5</Text>
      <div className={cx('itemList')}>{ItemEls}</div>

      <Link className={cx('rewardBanner')} href={'https://www.jobda.im/passboard/29'}>
        <div>
          <Text fontStyle={FontStyle.B2P_B} color={Colors.C_JOBDA_BLACK}>
            당신의 합격 스토리를 들려주세요.
          </Text>
          <Text
            fontStyle={FontStyle.B3_M}
            color={Colors.C_COOL_GRAY_60}
            styles={{ display: 'flex', alignItems: 'center', marginTop: '4px' }}
          >
            후기 작성자 전원 네이버페이 제공
            <Icon name="arrowRightLight" width={24} height={24} fill={Colors.C_COOL_GRAY_60} />
          </Text>
        </div>
        <div className={cx('lottieWrap')}>
          <Lottie options={options} />
        </div>
      </Link>
    </div>
  );
};

export default SideBanner;
